import { companyServiceApi } from "../../api";
import {
  FindCompanyByInnKppRequest,
  FindCompanyByInnKppResponse,
} from "../contract";

export const findCompanyByInnKpp = async (
  params: FindCompanyByInnKppRequest,
): Promise<FindCompanyByInnKppResponse> => {
  const response = await companyServiceApi.get<FindCompanyByInnKppResponse>(
    "companies",
    { params },
  );
  return response.data;
};
